import React from "react";
import stateJson from "./assets/state.json";

const STATE_OPTIONS = [...(stateJson.stateData || [])].sort((a, b) =>
  a.name.localeCompare(b.name)
);

/** Resolve API/display value to state code for the dropdown. */
export const getStateCode = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  const match = STATE_OPTIONS.find(
    (s) =>
      s.code === trimmed ||
      s.name.toLowerCase() === trimmed.toLowerCase()
  );
  return match?.code || trimmed;
};

export default function State({
  id = "state",
  name = "state",
  value = "",
  onChange,
  className = "",
  disabled = false,
}) {
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
    >
      <option value="">Select state</option>
      {STATE_OPTIONS.map((s) => (
        <option key={s.code} value={s.code}>
          {s.name}
        </option>
      ))}
    </select>
  );
}
